/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
"use client";

import Link from "next/link";
import styles from "./loginForm.module.css";

import { useForm } from "react-hook-form";
import { useState } from "react";
import { signIn } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";

const LoginForm = () => {
  const [error, setError] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const searchParams = useSearchParams();

  const onSubmit = async (data) => {
    try {
      const result = await signIn("credentials", {
        redirect: false,
        username: data.login,
        password: data.password,
      });

      if (result.error) {
        if (result.error === "INVALID_CREDENTIALS") {
          setError("Invalid username or password");
        } else {
          setError(result.error);
        }
      } else {
        const callbackUrl = searchParams.get("callbackUrl") || "/";
        // router.push(callbackUrl);
        window.location.href = callbackUrl;
      }
    } catch (error) {
      console.error("Error during sign-in:", error);
      setError("An unexpected error occurred");
    }
  };

  return (
    <div>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.fieldContainer}>
          <input
            placeholder="email"
            name="email"
            defaultValue=""
            {...register("login", { required: true })}
          />
          {errors.login && (
            <span className={styles.textError}> Ce champ est requis</span>
          )}
        </div>
        <div className={styles.fieldContainer}>
          <input
            placeholder="password"
            name="password"
            type="password"
            {...register("password", { required: true })}
          />

          {errors.password && (
            <span className={styles.textError}>Ce champ est requis</span>
          )}
        </div>
        <div className={styles.button}>
          <input type="submit" />
        </div>

        {error && <p style={{ color: "red" }}>{error}</p>}
        <Link href="/register">
          <div className={styles.register}>
            Vous n&apos;etes pas encore inscrit ? <b>Inscription</b>
          </div>
        </Link>
      </form>
    </div>
  );
};

export default LoginForm;
